// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAuth} from "firebase/auth";
import {getStorage} from "firebase/storage";


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDhgBOPiXnizYMEYWnartQgeGzzPRbUNEI",
    authDomain: "visad-8e9ec.firebaseapp.com",
    projectId: "visad-8e9ec",
    storageBucket: "visad-8e9ec.firebasestorage.app",
    messagingSenderId: "706421913533",
    appId: "1:706421913533:web:6384ff84cbfe78cae7c4d4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export {db, storage, auth};